import { SET_ACTIVE_MODULE } from "../actions/sideBarActions";
const initialState = {
    activeModule: null,
};

const sidebarReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACTIVE_MODULE:
            return { ...state, activeModule: action.payload };

        default:
            return state;
    }
};
export default sidebarReducer;
